const categories = [
  { name: '古风耽美', icon: 'ri-file-paper-line', desc: '权谋江湖 · 风骨柔情', count: '826部' },
  { name: '现代都市', icon: 'ri-building-line', desc: '职场生活 · 都市恋曲', count: '715部' },
  { name: '校园青春', icon: 'ri-book-2-line', desc: '青涩年华 · 纯爱物语', count: '634部' },
  { name: '奇幻异世', icon: 'ri-magic-line', desc: '异界冒险 · 魔法奇缘', count: '592部' },
  { name: '仙侠修真', icon: 'ri-cloud-line', desc: '修仙问道 · 仙魔情缘', count: '548部' },
  { name: '科幻星际', icon: 'ri-rocket-line', desc: '未来世界 · 星际旅程', count: '403部' },
  { name: '娱乐圈', icon: 'ri-mic-line', desc: '偶像星光 · 幕后深情', count: '387部' },
  { name: 'ABO设定', icon: 'ri-heart-pulse-line', desc: '命定之人 · 信息素', count: '356部' },
  { name: '悬疑推理', icon: 'ri-search-eye-line', desc: '暗流涌动 · 真相追寻', count: '298部' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50 scroll-mt-[64px]">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            专题合集
          </h2>
          <p className="text-sm text-foreground-500">按题材分类，快速找到你喜欢的免费耽美漫画</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href="#index"
              className="group flex items-center gap-3 p-4 md:p-5 bg-background-100 rounded-lg hover:bg-primary-50 transition-colors"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex-shrink-0 bg-primary-100 rounded-lg flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                <i className={`${cat.icon} text-lg md:text-xl text-primary-600`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 whitespace-nowrap">
                    {cat.name}
                  </h3>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{cat.count}</span>
                </div>
                <p className="text-xs text-foreground-500 line-clamp-1">{cat.desc}</p>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-primary-500 transition-colors flex-shrink-0"></i>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}